export const AddClient = "/client_manager/add_client";
export const GetAllClients = "/client_manager/all_clients";
export const GetAllClientsCmove = "/client_manager/all_clients_cmove";
export const UpdateClient = "/client_manager/update_client";
export const GetClientSubdomain = "/client_manager/client_subdomain";
export const GetClientAccess = "/client_manager/client_permissions";
export const PostClientAccess = "/client_manager/client_permissions";
export const UpdateClientLocation = "pacsLocations/client/update_location";
export const DeleteClientLocation = "pacsLocations/client/delete_location";
export const AddClientLocation = "pacsLocations/client/add_location";
